import { render, staticRenderFns } from "./limit-batch-approval-detail.vue?vue&type=template&id=5e75750e&scoped=true"
import script from "./limit-batch-approval-detail.vue?vue&type=script&lang=js"
export * from "./limit-batch-approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e75750e",
  null
  
)

export default component.exports